export default __webpack_public_path__ + "static/batman-28cc5ea56eabbfc1a2fbf2891deadb42.jpg";